//@flow
import {call, select} from 'redux-saga/effects'

import {setTokensState} from '$util'
import {isFetching} from '$src/requests/selectors'
import {selectRefreshToken} from '$src/auth/selectors'
import refreshTokens from '$src/auth/sagas/refreshTokens'

const RETRIES = 4

export default function * refreshOnAuthError(
  fn: Generator<> | (any => Promise<mixed>),
  ...args: Array<mixed>
): Generator<> {

  const refresh_token: ?string = yield select(selectRefreshToken)

  if (!refresh_token) {
    return
  }

  const isRefreshing: ?boolean = yield select(isFetching, 'refreshTokens')

  if (!isRefreshing) {

    yield call(refreshTokens)
  }

  for(let i = RETRIES; i--; i >= 0) {
    try {
      const result: Object = yield call(fn, ...args)
      return result
    } catch (e) {
      if (!i) {

        yield call(setTokensState)
        throw e
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/refreshOnAuthError.js